import React from 'react'
import PropTypes from 'prop-types'
import PerformanceRatingOrgSummaryReport from './PerformanceRatingOrgSummaryReport'
import DataFilters from '../../DataFilters'
import { round } from '../../../../../helpers'
import { range, find, get } from 'lodash'

export default function PerformanceRatingOrgSummary(props) {

    const groups = ['E', 'M', 'P', 'S']

    const groupsNames = {
        'E': 'Executive',
        'M': 'Management',
        'P': 'Professional',
        'S': 'Support',
    }

    const onApply = (filters) => {
        props.onApply(filters, 'PerformanceRatingOrgSummary')
    }

    const levelsData = []
    const groupSummary = {}
    const groupTotal = {
        current: {
            total_row: 0,
            total_average_rating: 0,
            totalN: 0,
            totalPercent: 0,
        }
    }

    range(14).forEach(level => {
        const levelData = props.masterData.jobGrades.filter(hd => hd.hierarchy === level)
        const groupData = {}
        groups.forEach(g => {
            groupData[g] = {
                level: '',
                title: '',
                current: { n: '', percent: '', salary: '' },
            }
        })

        groupSummary[level] = {
            current: { nSummary: 0, averageRatingSummary: 0, percentSummary: 0 },
        }

        let averageRatingCount = 0;

        levelData.forEach(ld => {
            const groupKey = ld.job_grade.slice(0, 1)
            const dataInReport = find(props.reportData, { 'compkit_job_grade': ld.job_grade })

            groupData[groupKey].level = ld.job_grade
            groupData[groupKey].title = ld.job_title

            if (dataInReport) {
                groupSummary[level].current.nSummary += dataInReport ? dataInReport.total : 0
                let averageRating = get(dataInReport, 'avg_performance_rating', 0)
                if (averageRating !== 0) {
                    averageRatingCount++;
                    groupSummary[level].current.averageRatingSummary += round(get(dataInReport, 'avg_performance_rating', 0))
                }
            }
        })

        groupSummary[level].current.averageRatingSummary = round(groupSummary[level].current.averageRatingSummary / averageRatingCount)
        groupTotal.current.totalN += groupSummary[level].current.nSummary
        levelsData.push(groupData)
    })

    range(14).forEach(level => {
        groupSummary[level].current.percentSummary = round((groupSummary[level].current.nSummary / groupTotal.current.totalN) * 100)
        groupTotal.current.totalPercent = round(groupTotal.current.totalPercent + groupSummary[level].current.percentSummary)
        groupSummary[level].current.averageRatingSummary = round(groupSummary[level].current.averageRatingSummary)
        groupTotal.current.total_average_rating += groupSummary[level].current.averageRatingSummary
        if (groupSummary[level].current.averageRatingSummary !== 0) {
            groupTotal.current.total_row += 1
        }
    })

    /**
	 * Below is the Display logic for Rows
	 */
    range(14).forEach(level => {
        groupSummary[level].current.averageRatingSummary = groupSummary[level].current.averageRatingSummary.toFixed(1)
    })

    groupTotal.current.total_average_rating = round(groupTotal.current.total_average_rating / groupTotal.current.total_row)
    groupTotal.current.totalPercent = round(groupTotal.current.totalPercent, 0).toFixed(1)

    return (
        <React.Fragment>
            <DataFilters
                fetchedFilterData={props.fetchedFilterData}
                filtersData={props.filtersData}
                onDataFilterSelect={props.onDataFilterSelect}
                componentName={'PerformanceRatingOrgSummary'}
                reportFilters={props.reportFilters}
                onApply={onApply}
                resetFilter={props.resetFilter}
                reportFiltersType={props.reportFiltersType}
                reportDataChanged={props.reportDataChanged}
            />
            <PerformanceRatingOrgSummaryReport groupTotal={groupTotal} groupSummary={groupSummary} groups={groups} groupsNames={groupsNames} levelsData={levelsData}></PerformanceRatingOrgSummaryReport>
        </React.Fragment>
    )
}

PerformanceRatingOrgSummary.propTypes = {
    masterData: PropTypes.object.isRequired,
    onDataFilterSelect: PropTypes.func.isRequired,
    reportFilters: PropTypes.object.isRequired,
    reportData: PropTypes.array.isRequired,
    onApply: PropTypes.func.isRequired,
}
